"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import CryptoJS from "crypto-js";
import md5 from "md5";
import API from "@ym-framework/api-utils";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
let ImportCookiesDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.shopName = "";
    this.cookies = null;
    this.id = "";
    this.row = null;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(item) {
    return __async(this, null, function* () {
      this.row = item;
      this.id = item.shopOldId;
      this.shopName = item.name;
      this.dialog.visible = true;
    });
  }
  cancelImport() {
    return __async(this, null, function* () {
      this.cookies = null;
      this.shopName = "";
      this.id = "";
      this.dialog.visible = false;
    });
  }
  importCookies() {
    return __async(this, null, function* () {
      try {
        if (this.cookies) {
          try {
            yield UiConfirm.warnconfirm(
              this.$t("importCookiesDialog.confirm_tip"),
              this.$t("headertoolbar.hint"),
              {
                confirmButtonText: this.$t("headertoolbar.confirm"),
                cancelButtonText: this.$t("headertoolbar.cancel"),
                iconClass: "el-icon-warning"
              }
            );
          } catch (error) {
            this.cancelImport();
            return;
          }
          let flag = this.checkJson(this.cookies);
          if (!flag) {
            this.$message.error(this.$t("importCookiesDialog.import_cookie_wrong_type"));
            return;
          }
          let jsonData = JSON.parse(this.cookies);
          if (!Array.isArray(jsonData)) {
            this.$message.error(this.$t("importCookiesDialog.import_cookie_wrong_type_2"));
            return;
          }
          for (const cookieItem of jsonData) {
            for (let key in cookieItem) {
              let key_new = key.replace(key[0], key[0].toLowerCase());
              if (key_new === key) {
                continue;
              } else {
                cookieItem[key_new] = cookieItem[key];
                delete cookieItem[key];
              }
            }
          }
          if (this.row.marks.tags.includes("NO_AUTO_SYNC")) {
            yield API.post(`api://base.auth/api/v8/shop-cookies/${this.id}`, {
              "model": "import.sync",
              "cookies": this.encryptData(JSON.stringify(jsonData)),
              "cookieMD5": md5(JSON.stringify(jsonData))
            });
            yield UiConfirm.warnconfirm(
              this.$t("importCookiesDialog.no_auth_sync_tip"),
              this.$t("headertoolbar.hint"),
              {
                confirmButtonText: this.$t("headertoolbar.confirm"),
                cancelButtonText: this.$t("headertoolbar.cancel"),
                iconClass: "el-icon-warning"
              }
            );
            this.$message.success(this.$t("importCookiesDialog.import_cookie_success"));
            this.cancelImport();
            return;
          }
          if (this.row.marks.tags.includes("AUTO_SYNC")) {
            yield API.post(`api://base.auth/api/v8/shop-cookies/${this.id}`, {
              "model": "import.sync",
              "cookies": this.encryptData(JSON.stringify(jsonData)),
              "cookieMD5": md5(JSON.stringify(jsonData))
            });
            this.$message.success(this.$t("importCookiesDialog.import_cookie_success"));
            this.cancelImport();
            return;
          }
          if (this.row.marks.tags.includes("MANUAL_SYNC")) {
            yield API.post(`api://base.auth/api/v8/shop-cookies/${this.id}`, {
              "model": "import.sync",
              "cookies": this.encryptData(JSON.stringify(jsonData)),
              "cookieMD5": md5(JSON.stringify(jsonData))
            });
            yield UiConfirm.warnconfirm(
              this.$t("importCookiesDialog.manual_sync_tip"),
              this.$t("headertoolbar.hint"),
              {
                confirmButtonText: this.$t("headertoolbar.confirm"),
                cancelButtonText: this.$t("headertoolbar.cancel"),
                iconClass: "el-icon-warning"
              }
            );
            this.$message.success(this.$t("importCookiesDialog.import_cookie_success"));
            this.cancelImport();
            return;
          }
          if (this.row.marks.tags.includes("BYUSER_SYNC")) {
            yield API.post(`api://base.auth/api/v8/shop-cookies/${this.id}`, {
              "model": "import.sync",
              "cookies": this.encryptData(JSON.stringify(jsonData)),
              "cookieMD5": md5(JSON.stringify(jsonData))
            });
            this.$message.success(this.$t("importCookiesDialog.import_cookie_success"));
            this.cancelImport();
            return;
          }
        } else {
          this.$message.error(this.$t("importCookiesDialog.import_cookie_error"));
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  checkJson(str) {
    try {
      if (typeof JSON.parse(str) == "object") {
        return true;
      }
    } catch (error) {
    }
    return false;
  }
  encryptData(datas) {
    const key = CryptoJS.enc.Utf8.parse("7fe7df58b0faa649");
    const srcs = CryptoJS.enc.Utf8.parse(datas);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString().toUpperCase();
  }
};
ImportCookiesDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], ImportCookiesDialog);
export {
  ImportCookiesDialog as default
};
